import React from 'react';
import {Grid, Link} from "@material-ui/core";

import leftImage from '../../../images/HowTo.png';
import abdtdotShape from '../../../images/abdtdotshape.png';

import './style.scss';

const HomeHowTo = () => {
    return(
        
        <Grid className="HowItWorksWrapper">
            <Grid
                container
                spacing={4}
                alignItems="center"
                className="container"
            >
                <Grid item xs={12} md={5}>
                    <Grid className="thumb">
                        <img src={leftImage} alt="leftImage"/>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Grid className="introList">
                        <span>01</span>
                        <h4>One</h4>
                        <p>Drop in your general information including the name and address of the employer, employee name, and pay period. Hit that next button! </p>
                    </Grid>
                    <Grid className="introList">
                        <span>02</span>
                        <h4>Two</h4>
                        <p>Enter your employee’s payment information including income amount and type, taxable benefits, deductions, and everything you’d like to see on your pay stub. </p>
                    </Grid>
                    <Grid className="introList">
                        <span>Pay</span>
                        <h4>Pay</h4>
                        <p>You are ready to preview your pay stub! If everything looks good you can download it right away.</p>
                        <br/><br/>
                        <Link to="/about-us" className="cBtn">Learn More</Link>
                    </Grid>
                </Grid>    
            </Grid>
            
            <img src={abdtdotShape} alt="abdtdotShape" className="abdtdotShape"/>
        </Grid>
    )
};

export default HomeHowTo;